import { z } from 'zod'
import { type AddToCartEvent, type BeginCheckoutEvent, type PurchaseEvent, type SalesEventCartItem, type ViewItemEvent } from '../types/base/ga4-events'
import { AddToCartStatus } from '../types/wordpress-ga4-events'

const ItemSchema: z.ZodType<SalesEventCartItem> = z.object({
  currency: z.string(),
  item_id: z.string(),
  item_name: z.string(),
  price: z.number(),
  quantity: z.number(),
  item_brand: z.string(),
  item_variant: z.string(),
})

const StatusCodeSchema = z.enum([AddToCartStatus.MEMBER_ONLY.code, AddToCartStatus.SUCCESS.code])
const StatusMessageSchema = z.enum([AddToCartStatus.MEMBER_ONLY.message, AddToCartStatus.SUCCESS.message])

export const AddToCartEventSchema: z.ZodType<AddToCartEvent> = z.object({
  eventName: z.literal('add_to_cart'),
  eventParams: z.object({
    currency: z.string(),
    value: z.number(),
    items: z.array(ItemSchema),
    status_code: StatusCodeSchema,
    status_message: StatusMessageSchema,
  }),
})

export const ViewItemEventSchema: z.ZodType<ViewItemEvent> = z.object({
  eventName: z.literal('view_item'),
  eventParams: z.object({
    currency: z.string(),
    value: z.number(),
    items: z.array(ItemSchema),
  }),
})

export const BeginCheckoutEventSchema: z.ZodType<BeginCheckoutEvent> = z.object({
  eventName: z.literal('begin_checkout'),
  eventParams: z.object({
    currency: z.string(),
    value: z.number(),
    items: z.array(ItemSchema),
    coupon: z.string().optional(),
  }),
})

export const PurchaseEventSchema: z.ZodType<PurchaseEvent> = z.object({
  eventName: z.literal('purchase'),
  eventParams: z.object({
    currency: z.string(),
    value: z.number(),
    items: z.array(ItemSchema),
    transaction_id: z.string(),
    coupon: z.string().optional(),
    shipping: z.number().optional(),
    tax: z.number().optional(),
  }),
})
